import { render, staticRenderFns } from "./header-body.vue?vue&type=template&id=6bc5720f&scoped=true"
import script from "./header-body.vue?vue&type=script&lang=js"
export * from "./header-body.vue?vue&type=script&lang=js"
import style0 from "./header-body.vue?vue&type=style&index=0&id=6bc5720f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc5720f",
  null
  
)

export default component.exports